import type { WixComponentManifest } from '@wix/component-protocol/schema';
import { EditorPointer } from '../types';

function getMostInnerElementManifest(
  element: WixComponentManifest,
  pathArray: string[],
): any {
  for (const key of pathArray.slice(1)) {
    if (
      element &&
      typeof element === 'object' &&
      element.elements &&
      key in element.elements
    ) {
      element = element.elements[key];
    } else {
      return null;
    }
  }
  return element;
}

export function getElementManifestByInnerElementPath(
  manifest: WixComponentManifest | null,
  innerElementPath: EditorPointer['innerElementPath'],
) {
  if (!manifest) {
    return null;
  }

  if (!innerElementPath || innerElementPath.length <= 1) {
    return manifest;
  }

  return getMostInnerElementManifest(manifest, innerElementPath);
}
